module.exports = __webpack_public_path__ + "static/media/tokyo2.b2cbbea1.jpg";